import { useQuery } from '@tanstack/react-query'
import { useActions } from '../providers'
import { useGlobalEvent } from '@highlight/ipc'

export const useAudioNotes = () => {
  const { getAudioNotes } = useActions()
  const { data, refetch, ...rest } = useQuery({
    queryKey: ['audio-notes'],
    queryFn: getAudioNotes,
    // Normalize output so consumers always get a flat AudioNote[]
    select: (result: any) => {
      if (!result) return []
      if (Array.isArray(result)) return result

      // Support shapes like { data: AudioNote[] }
      if (Array.isArray(result?.data)) return result.data

      // Support shapes like { pages: [ { data: AudioNote[] } | AudioNote[] ] }
      if (Array.isArray(result?.pages)) {
        const flattened = result.pages.flatMap((page: any) => {
          if (Array.isArray(page)) return page
          if (Array.isArray(page?.data)) return page.data
          return []
        })
        return flattened
      }

      return []
    },
  })

  return { data, refetch, ...rest }
}
